import React, { forwardRef } from 'react';
import { bool, func, shape, string } from 'prop-types';

import ClassNames from 'classnames';

import './RadioButton.scss';

const RadioButton = forwardRef(
  (
    {
      autoFocus,
      checked,
      className,
      defaultChecked,
      disabled,
      id,
      name,
      onBlur,
      onChange,
      style,
      value
    },
    ref
  ) => {
    const changeHandler = event => {
      if (onChange) {
        onChange(event.target.checked, event.target.value);
      }
    };

    return (
      <span
        className={ClassNames([
          'radio-button-container',
          checked && 'checked',
          disabled && 'disabled'
        ])}
        style={style}
      >
        <input
          // TODO: Reconsider use of the autoFocus prop.
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus={autoFocus}
          checked={checked}
          className={ClassNames(['radio-button', className])}
          defaultChecked={defaultChecked}
          disabled={disabled}
          id={id}
          name={name}
          onBlur={onBlur}
          onChange={changeHandler}
          ref={ref}
          type="radio"
          value={value}
        />
        <span className="radio-button-inner" />
      </span>
    );
  }
);

RadioButton.propTypes = {
  autoFocus: bool,
  checked: bool,
  className: string,
  defaultChecked: bool,
  disabled: bool,
  id: string,
  name: string,
  onBlur: func,
  onChange: func,
  style: shape({}),
  value: string
};

RadioButton.defaultProps = {
  autoFocus: false,
  checked: undefined,
  className: '',
  defaultChecked: undefined,
  disabled: false,
  id: undefined,
  name: '',
  onBlur: () => {},
  onChange: undefined,
  style: {},
  value: undefined
};

export default RadioButton;
